import { PLATFORM_API_URL } from '../constants/api';

const getAPIUrl = wixCodeApi => {
  if (wixCodeApi.window.rendering.env !== 'backend') {
    return PLATFORM_API_URL;
  }

  const baseUrl = wixCodeApi.location.baseUrl;
  if (baseUrl.includes('wixsite.com')) {
    return `${baseUrl.substring(0, baseUrl.lastIndexOf('/'))}${PLATFORM_API_URL}`;
  }

  return `${baseUrl.replace(/(https?:\/\/[^/]+)\/.+/, '$1')}${PLATFORM_API_URL}`;
};

export default {
  getAPIUrl,
};
